import { IRootState } from '@/store';
import { ActionTree } from 'vuex';
import { ITakeTeilnehmerState } from './state';

import {
    LOADING_TEILNEHMER,
    OFFSET_TEILNEHMER,
    TOTAL_NUMBER_OF_RECORDS_TEILNEHMER,
    ADD_TEILNEHMERLIST,
    MAP_TEILNEHMERLIST,
    LOADING_BENUTZER,
    MAPBENUTZERDATA,
    MAPBENUTZERDETAILS,
    MAPPRAXISGRUPPEBENUTZERDATA
} from './mutations';
import { NAME } from './';

import { takeTeilnehmerService } from '../services/TakeTeilnehmerService';
import { benutzerinfoService } from '../services/BenutzerinfoService';
import { CLOSE_MODAL, NEW_MODAL_ERROR, NEW_SUCESS } from '@/store/modules/headerNotification/actions';
import { GET_PERMISSIONS, GET_BENUTZERINFO } from '@/store/modules/security/actions';
import { SHOW, HIDE } from '@/store/modules/loadingSpinner/actions';
import { BenutzerCreateApiDto, BenutzerEditApiDto, TakeTeilnehmerApiDto } from '@/api-schema';
import { BenutzerInfoSearchApiDto } from '@/types/BenutzerInfoSearchApiDto';
import { praxisgruppeProfilService } from '../services/PraxisgruppeProfilService';
import { i18n } from '@/plugins/i18n';
import { securityService } from '@/services/securityService';

export const TAKESPECIFIC = 'TakeSpecific';
export const RESET = 'Reset';
export const GET_TEILNEHMER = 'GetTeilnehmer';
export const GET_NEXT_TEILNEHMER = 'GetNextTeilnehmer';
export const GET_BENUTZER = 'GetBenutzer';
export const GET_BENUTZER_DETAILS = 'getBenutzerDetails';
export const DELETE_ACCOUNT = 'deleteBenutzerAccount';
export const EDIT_ACCOUNT = 'editBenutzerAccount';
export const GET_EDIT_ACCOUNT = 'getAccountToEdit';
export const ADD_ACCOUNT = 'addBenutzerAccount';
export const GET_BENUTZER_BY_ID = 'getPraxisgruppeBenutzer';
export const RESET_MFA = 'resetMfa';

export const actions: ActionTree<ITakeTeilnehmerState, IRootState> = {
    async [TAKESPECIFIC]({ dispatch }: any, teilnehmer: TakeTeilnehmerApiDto) {
        console.debug(NAME + '::' + TAKESPECIFIC);

        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        await takeTeilnehmerService.takeSpecific(teilnehmer).then(async () => {
            //Reload Permissions
            await dispatch('security/' + GET_PERMISSIONS, {}, { root: true });
            console.log('permissions loaded after setting specific user');
            await dispatch('security/' + GET_BENUTZERINFO, {}, { root: true });
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            dispatch(
                'headerNotification/' + NEW_SUCESS,
                {
                    text:
                        'Rolle wurde erfolgreich gewechselt mit TeilnehmerId: ' +
                        teilnehmer.teilnehmerId +
                        ' bzw. tvsKundennummer: ' +
                        teilnehmer.tvsKundennummer +
                        ' und Rolle: ' +
                        teilnehmer.benutzerRolle
                },
                { root: true }
            );
        });
    },

    async [RESET]({ dispatch }: any) {
        console.debug(NAME + '::' + RESET);

        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        await securityService.resetContext().then(async () => {
            //Reload Permissions
            await dispatch('security/' + GET_PERMISSIONS, {}, { root: true });
            await dispatch('security/' + GET_BENUTZERINFO, {}, { root: true });
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            dispatch('headerNotification/' + NEW_SUCESS, { text: 'Rolle erfolgreich zurückgesetzt' }, { root: true });
        });
    },

    async [GET_NEXT_TEILNEHMER]({ commit, state }: any) {
        console.debug(NAME + '::' + GET_NEXT_TEILNEHMER);

        if (state.teilnehmerLoading || (state.teilnehmerFilter.offset !== 0 && state.teilnehmerFilter.offset >= state.teilnehmerTotalNumberOfRecords)) {
            return;
        }

        commit(LOADING_TEILNEHMER, true);
        commit(OFFSET_TEILNEHMER, state.teilnehmerList.length);

        await takeTeilnehmerService.getTeilnehmer(state.teilnehmerFilter).then((response) => {
            commit(TOTAL_NUMBER_OF_RECORDS_TEILNEHMER, response.totalNumberOfRecords);
            commit(ADD_TEILNEHMERLIST, response.entries);
            commit(LOADING_TEILNEHMER, false);
        });
    },
    async [GET_TEILNEHMER]({ commit, state }: any) {
        console.debug(NAME + '::' + GET_TEILNEHMER);

        if (state.teilnehmerLoading || (state.teilnehmerFilter.offset !== 0 && state.teilnehmerFilter.offset >= state.teilnehmerTotalNumberOfRecords)) {
            return;
        }

        commit(LOADING_TEILNEHMER, true);
        commit(OFFSET_TEILNEHMER, 0);

        await takeTeilnehmerService.getTeilnehmer(state.teilnehmerFilter).then((response) => {
            commit(TOTAL_NUMBER_OF_RECORDS_TEILNEHMER, response.totalNumberOfRecords);
            commit(MAP_TEILNEHMERLIST, response.entries);
            commit(LOADING_TEILNEHMER, false);
        });
    },
    async [GET_BENUTZER]({ dispatch, commit, state }: any) {
        console.debug(NAME + '::' + GET_BENUTZER);

        commit(LOADING_BENUTZER, true);
        const searchQuery: BenutzerInfoSearchApiDto = Object.assign({}, state.benutzerFilter);
        await benutzerinfoService
            .getByEmail(searchQuery)
            .then((response) => {
                commit(MAPBENUTZERDATA, response);
            })
            .catch(() => {
                commit(MAPBENUTZERDATA, null);
            })
            .finally(() => {
                commit(LOADING_BENUTZER, false);
            });
    },
    [ADD_ACCOUNT]({ dispatch, state }: any, benutzer: BenutzerCreateApiDto) {
        console.debug(NAME + '::' + ADD_ACCOUNT, benutzer);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        dispatch('headerNotification/' + CLOSE_MODAL, {}, { root: true });

        return praxisgruppeProfilService
            .addBenutzer(benutzer)
            .then((response) => {
                dispatch(GET_BENUTZER_BY_ID);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                return true;
            })
            .catch((response) => {
                dispatch('headerNotification/' + NEW_MODAL_ERROR, { text: i18n.global.t('einstellungen.errormessage.duplicateaccount') }, { root: true });
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                return false;
            });
    },
    [GET_BENUTZER_DETAILS]({ commit }: any, id: string) {
        console.debug(NAME + '::' + GET_BENUTZER_DETAILS, id);

        praxisgruppeProfilService.getBenutzerDetails(id).then((response) => {
            commit(MAPBENUTZERDETAILS, response, id);
        });
    },
    [EDIT_ACCOUNT]({ dispatch }: any, benutzer: BenutzerEditApiDto) {
        console.debug(NAME + '::' + EDIT_ACCOUNT, benutzer);

        return praxisgruppeProfilService.editBenutzer(benutzer).then((response) => {
            if (response.isSuccess) {
                dispatch(GET_BENUTZER_BY_ID);
            }
        });
    },
    async [GET_EDIT_ACCOUNT]({ commit }: any, objectBenutzerId: string) {
        console.debug(NAME + '::' + GET_EDIT_ACCOUNT, objectBenutzerId);

        return praxisgruppeProfilService.getEditAccount(objectBenutzerId).then((response) => {
            return response;
        });
    },
    [DELETE_ACCOUNT]({ dispatch }: any, objectBenutzerId: string) {
        console.debug(NAME + '::' + DELETE_ACCOUNT, objectBenutzerId);

        return praxisgruppeProfilService.deleteBenutzer(objectBenutzerId).then((response) => {
            if (response) {
                dispatch(GET_BENUTZER_BY_ID);
            }
        });
    },
    [GET_BENUTZER_BY_ID]({ commit, state, dispatch }: any) {
        console.debug(NAME + '::' + GET_BENUTZER_BY_ID);
        praxisgruppeProfilService.getBenutzer().then((response) => {
            commit(MAPPRAXISGRUPPEBENUTZERDATA, response);
        });
    },
    [RESET_MFA]({ dispatch }: any, objectBenutzerId: string) {
        console.debug(NAME + '::' + RESET_MFA, objectBenutzerId);
        return praxisgruppeProfilService
            .resetMfa(objectBenutzerId)
            .then((response) => {
                if (response) {
                    dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('einstellungen.success.resetmfa') }, { root: true });
                }
            })
            .catch((response) => {
                dispatch('headerNotification/' + NEW_MODAL_ERROR, { text: i18n.global.t('einstellungen.errormessage.resetmfa') }, { root: true });
            });
    }
};
